// extracted by mini-css-extract-plugin
module.exports = {"sidebarContainer":"Sidebar_sidebarContainer__2Tvae","sidebarBase":"Sidebar_sidebarBase__2zp61"};